'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _haversine = require('haversine');

var _haversine2 = _interopRequireDefault(_haversine);

var _caligramReact = require('caligram-react');

var _events = require('redux/modules/events');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    push: _reduxRouter.push,
    dispatchSetMapCenter: function dispatchSetMapCenter(newCenter) {
      dispatch((0, _events.setMapCenter)(newCenter));
    },
    dispatchGeoIndex: function dispatchGeoIndex(center, radius) {
      dispatch((0, _events.geoIndex)(center, radius));
    }
  };
};

var DynamicMapContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    events: state.events.geoData,
    loading: state.events.loading,
    location: state.router.location,
    map: state.events.map
  };
}, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DynamicMapContainer, _Component);

  function DynamicMapContainer() {
    (0, _classCallCheck3.default)(this, DynamicMapContainer);
    return (0, _possibleConstructorReturn3.default)(this, (DynamicMapContainer.__proto__ || (0, _getPrototypeOf2.default)(DynamicMapContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(DynamicMapContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateQuery({
        mapView: true,
        page: undefined
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(query) {
      var location = this.props.location;

      var newQuery = (0, _extends3.default)({}, location.query, query);
      var newLocation = (0, _extends3.default)({}, location, {
        query: newQuery
      });

      this.context.router.push(newLocation);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$map = this.props.map,
          centerLat = _props$map.centerLat,
          centerLng = _props$map.centerLng,
          initialZoom = _props$map.initialZoom;
      var _props = this.props,
          dispatchGeoIndex = _props.dispatchGeoIndex,
          dispatchSetMapCenter = _props.dispatchSetMapCenter;
      var _props2 = this.props,
          events = _props2.events,
          loading = _props2.loading,
          push = _props2.push; // eslint-disable-line no-shadow

      var mapEvents = [];
      var eventsById = [];

      events.filter(function (ev) {
        return ev.venue.latitude && ev.venue.longitude;
      }).map(function (ev) {
        if (!eventsById[ev.id]) {
          ev.lat = ev.venue.latitude;
          ev.lng = ev.venue.longitude;

          mapEvents.push(ev);
          eventsById[ev.id] = ev;
        }
      });

      var properties = {
        apiKey: _config2.default.app.googleMaps.apiKey,
        centerLat: centerLat,
        centerLng: centerLng,
        events: mapEvents,
        initialZoom: initialZoom,
        className: { loading: loading },
        handleOnClick: function handleOnClick(id) {
          var eventObj = eventsById[id];
          push({ pathname: '/evenements/' + eventObj.slug + '/' + eventObj.id }, {
            date: eventObj.date
          });
        },
        marker: _caligramReact.MapMarker,
        onCenterChange: function onCenterChange(mapData) {
          var radius = (0, _haversine2.default)({
            latitude: mapData.center.lat,
            longitude: mapData.center.lng
          }, {
            latitude: mapData.bounds.nw.lat,
            longitude: mapData.bounds.nw.lng
          }, { unit: 'meter' });

          dispatchSetMapCenter(mapData);

          dispatchGeoIndex(mapData.center, radius);
        }
      };

      return _react2.default.createElement(_caligramReact.GeolocatedDynamicMap, { mapProps: properties });
    }
  }]);
  return DynamicMapContainer;
}(_react.Component), _class2.propTypes = {
  dispatchGeoIndex: _react.PropTypes.func.isRequired,
  dispatchSetMapCenter: _react.PropTypes.func.isRequired,
  events: _react.PropTypes.array,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  map: _react.PropTypes.object,
  push: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  moment: _react.PropTypes.func,
  router: _react.PropTypes.object
}, _temp)) || _class);
exports.default = DynamicMapContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DynamicMapContainer.js
// module id = 1175
// module chunks = 0